export const banner = {
  msrp: 29.99,
  infoLink: 'https://www.teamtriton.com/custom-banners.html',
  items: [
    {
      number: 'CB1',
      hasModel: false,
    },
    {
      number: 'CB2',
      hasModel: false,
    },
    {
      number: 'CB3',
      hasModel: false,
    },
    {
      number: 'CB4',
      hasModel: false,
    },
  ],
};
